import { withFieldGroup } from '@massilia/features'
import { Button, cn, useIsMobile } from '@massilia/ui'
import { ArrowLeftRight } from 'lucide-react'
import { useState } from 'react'

import type { FlightLegType } from '@/lib/schemas'

export const FlightLegRowFormGroup = withFieldGroup({
  defaultValues: {} as FlightLegType,
  props: {
    dateType: 'range',
    errorPopoverSide: 'bottom',
    errorsDisplayType: 'popover',
  } as {
    dateType: 'range' | 'single'
    disabledDateFn?: (date: Date) => boolean
    errorPopoverSide?: 'bottom' | 'top'
    errorsDisplayType?: 'bellow' | 'popover'
  },
  render: function Render({
    dateType,
    disabledDateFn,
    errorPopoverSide = 'bottom',
    errorsDisplayType = 'popover',
    group,
  }) {
    const isMobile = useIsMobile()
    const [isRotated, setIsRotated] = useState(false)

    return (
      <div className="flex flex-1 flex-col flex-wrap gap-2 md:grid md:grid-cols-[3fr_1fr]">
        <div
          className={cn('relative flex flex-1 flex-col gap-3 md:flex-row', { 'w-full': isMobile })}
        >
          <div className="flex-1">
            <group.AppField name="departure">
              {(field) => (
                <field.AirportAutocompleteField
                  errorPopoverSide={errorPopoverSide}
                  errorsDisplayType={errorsDisplayType}
                  mode="departure"
                />
              )}
            </group.AppField>
          </div>

          <Button
            className={cn(
              'border-gray-light-300 absolute top-1/2 left-1/2 z-20 rounded-full border bg-white'
            )}
            onClick={() => {
              const departure = group.getFieldValue('departure')
              const destination = group.getFieldValue('destination')
              group.setFieldValue('departure', destination)
              group.setFieldValue('destination', departure)
              setIsRotated(!isRotated)
            }}
            type="button"
            variant="ghost"
            style={{ transform: 'translate(-50%, -50%)' }}
          >
            <ArrowLeftRight
              className={cn('text-brand-600 size-4 transition-transform duration-300', {
                'rotate-180': isRotated,
                'size-3': isMobile,
              })}
            />
          </Button>

          <div className="flex-1">
            <group.AppField name="destination">
              {(field) => (
                <field.AirportAutocompleteField
                  errorPopoverSide={errorPopoverSide}
                  errorsDisplayType={errorsDisplayType}
                  mode="destination"
                />
              )}
            </group.AppField>
          </div>
        </div>

        {dateType === 'range' ? (
          <group.AppField name="date">
            {(field) => (
              <field.MultiDateField
                disabled={(date) => {
                  const today = new Date()
                  today.setHours(0, 0, 0, 0)
                  return date < today
                }}
                errorsDisplayType={errorsDisplayType}
              />
            )}
          </group.AppField>
        ) : (
          <group.AppField name="date.from">
            {(field) => (
              <field.CalendarField
                disabled={disabledDateFn}
                errorsDisplayType={errorsDisplayType}
              />
            )}
          </group.AppField>
        )}
      </div>
    )
  },
})
